import React from 'react';
import { FormattedMessage } from 'react-intl';

export default ({ currencyCode }) => {
  return (
    <p className="small-print multi-currency-notice">
      <FormattedMessage
        id="multiCurrencyNotice.currencyUsedMessage"
        defaultMessage="All charges will be made in {currency}"
        values={{ currency: currencyCode.toUpperCase() }}
      />
      {' '}
      <FormattedMessage
        id="multiCurrencyNotice.conversionMessage"
        defaultMessage="using the conversion rate at the time the payment is made."
      />
    </p>
  );
};



// WEBPACK FOOTER //
// ./src/desktop/components/multi-currency-notice.js